







































import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'QuantityInput',
  props: {
    max: {
      type: Number,
      default: 100,
    },
    value: {
      type: Number,
      default: 1,
    },
  },
  setup(props, { emit }) {
    function onChange(e: Event) {
      emit('input', (e.target as HTMLInputElement).value);
    }

    function increase() {
      if (props.value >= props.max) {
        return;
      }

      emit('input', props.value + 1);
    }

    function decrease() {
      if (props.value <= 1) {
        return;
      }
      emit('input', props.value - 1);
    }

    return {
      onChange,
      increase,
      decrease,
    };
  },
});
